import type { PageMeta } from "@/services/pageMeta";

function upsertMeta(selector: string, attrs: Record<string, string>) {
  let el = document.querySelector<HTMLMetaElement>(selector);
  if (!el) {
    el = document.createElement("meta");
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => el!.setAttribute(k, v));
}

export function applyHead(meta?: PageMeta) {
  const title = meta?.title?.trim() || "X-Global";
  const desc =
    meta?.description?.trim() ||
    "Маркетплейс X-Global — проверенные поставщики и безопасные сделки.";

  // Title
  document.title = title;

  // Description
  upsertMeta('meta[name="description"]', {
    name: "description",
    content: desc,
  });

  // Open Graph
  upsertMeta('meta[property="og:title"]', {
    property: "og:title",
    content: title,
  });
  upsertMeta('meta[property="og:description"]', {
    property: "og:description",
    content: desc,
  });

  // Twitter
  upsertMeta('meta[name="twitter:title"]', {
    name: "twitter:title",
    content: title,
  });
  upsertMeta('meta[name="twitter:description"]', {
    name: "twitter:description",
    content: desc,
  });
}
